const navArticle = new Component({
  component: document.querySelectorAll('.nav_article'),
  callback: component => {
    const navArticleAnchor = new Component({
      component: document.querySelectorAll(`[data-anchor=heading]`),
      callback: el => {
        const li = new Element({
          type: 'li',
          classes: 'nav_article-list_item',
          append: {
            parent: component.getElementsByTagName('ul')[0],
          },
        });

        const a = new Element({
          type: 'a',
          href: `#${el.id}`,
          classes: 'nav_article-link',
          content: el.innerHTML,
          append: {
            parent: li,
          },
        });
      },
    });
  },
});

const navArticleScroll = () => {
  const manualOffset = 33,
    secondaryNavHeight = document.getElementsByClassName('nav_secondary')[0]
      ? document.getElementsByClassName('nav_secondary')[0].offsetHeight
      : 0;
  primaryNavHeight =
    document.getElementsByClassName('nav_primary')[0].offsetHeight;
  let windowOffset = window.scrollY;

  const nav = new Component({
    component: document.querySelectorAll('.nav_article'),
    callback: () => {
      const highlightNav = () => {
        new Component({
          component: document.querySelectorAll(`[data-anchor=heading]`),
          callback: (el, allEl, index) => {
            const offset = primaryNavHeight + secondaryNavHeight + manualOffset;

            if (allEl[index + 1]) {
              if (
                windowOffset >= el.offsetTop - offset &&
                windowOffset < allEl[index + 1].offsetTop - offset
              ) {
                document
                  .querySelector(`[href="#${el.id}"]`)
                  .parentElement.classList.add('active');
              } else {
                document
                  .querySelector(`[href="#${el.id}"]`)
                  .parentElement.classList.remove('active');
              }
            } else {
              if (windowOffset >= el.offsetTop - offset) {
                document
                  .querySelector(`[href="#${el.id}"]`)
                  .parentElement.classList.add('active');
              } else {
                document
                  .querySelector(`[href="#${el.id}"]`)
                  .parentElement.classList.remove('active');
              }
            }
          },
        });
      };

      window.addEventListener('scroll', function () {
        windowOffset = this.scrollY;
        highlightNav();
      });

      highlightNav();
    },
  });
};
navArticleScroll();
